import { CUSTOMER_LIST_PATH } from './customerListFilters'

/** The tab the customer page opens on — it owns the bare customer URL, with no tab segment. */
export const CUSTOMER_DEFAULT_TAB = 'overview'

/** The staff page that fills a customer's whole application at once. */
export const CUSTOMER_FILL_APPLICATION_TAB = 'intake'

/** The customer's quotes page, as staff see it. */
export const CUSTOMER_QUOTES_TAB = 'quotes'

/**
 * Where one of a customer's tabs lives: `/insure/internal/customers/<id>/coi`.
 * `rest` is the tab's own place inside itself, e.g. the vault's `equipment/trucks/<id>`.
 */
export function customerTabHref(orgId: string, tab: string = CUSTOMER_DEFAULT_TAB, rest = ''): string {
  const base = `${CUSTOMER_LIST_PATH}/${orgId}`
  if (tab === CUSTOMER_DEFAULT_TAB) return base
  return rest ? `${base}/${tab}/${rest}` : `${base}/${tab}`
}
